/**
 * 存储localStorage
 */
export const setLocalStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}
/**
 * 获取localStorage
 */
export const getLocalStore = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}
/**
 * 删除localStorage
 */
export const removeLocalStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}
/**
 * 清除localStorage
 */
export const clearLocalStore = () => {
  window.localStorage.clear()
}
/**
 * 存储sessionStorage
 */
export const setSessionStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(name, content)
}

/**
 * 获取sessionStorage
 */
export const getSessionStore = name => {
  if (!name) return
  return window.sessionStorage.getItem(name)
}

/**
 * 删除sessionStorage
 */
export const removeSessionStore = name => {
  if (!name) return
  window.sessionStorage.removeItem(name)
}

/**
 * 获取cookie
 * @param name
 * @returns {string|null}
 */
export const getCookie = name => {
  let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return null;
}

/**
 * 设置cookie,增加到vue实例方便全局调用
 * @param c_name
 * @param value
 * @param expiredays
 */
export function setCookie(c_name, value, expiredays) {
  let exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
};

/**
 * 删除cookie
 * @param name
 */
export function delCookie(name) {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};
/**
 * 根据value获取label
 * */
export const getLabelByVal = (list, val) => {
  if (list && list.length > 0) {
    for (let i = 0; i < list.length; i++) {
      if (list[i].value === val) {
        return list[i].label
      }
    }
  }
}
/**
 * 检查value是否在集合set中
 * */
export const chkValueInSet = (sets, val) => {
  if (sets && sets.length > 0) {
    for (let i = 0; i < sets.length; i++) {
      if (list[i].value === val) {
        return true
      }
    }
    return false;
  } else
    return false;
}
/**
 * 未连接添加凭据字符串
 * @param urlstr
 * @param skey
 */
export const formatUrl = (urlstr, skey) => {
  return (urlstr === null) ? "" : (urlstr + (urlstr.includes("?") ? '&' : '?') + 'sk=' + skey)
}

/**
 * 格式化日期或时间，当type为dateTime时，输出日期加时间
 * */
export const formatDate = (date, type) => {
  function formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
  };
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hour = date.getHours();
  let minute = date.getMinutes();
  let second = date.getSeconds();
  let targetDate = [year, month, day].map(formatNumber).join('-');
  if (type && type === 'dateTime') targetDate = targetDate + ' ' + [hour, minute, second].map(formatNumber).join(':');
  return targetDate
}
/**
 * 格式化Timestamp日期或时间，当type为dateTime时，输出日期加时间
 * */
export const formatTimestamp2Date = (Timestamp, type) => {
  let date = new Date(Timestamp);
  return formatDate(date, type)
}
/**
 * 获取时间（time）的前num天或后num天（负数）
 */
export const getBeforeDate = (num, time) => {
  let n = num;
  let d = '';
  if (time) {
    d = new Date(time);
  } else {
    d = new Date();
  }
  let year = d.getFullYear();
  let mon = d.getMonth() + 1;
  let day = d.getDate();
  if (day <= n) {
    if (mon > 1) {
      mon = mon - 1;
    } else {
      year = year - 1;
      mon = 12;
    }
  }
  d.setDate(d.getDate() - n);
  year = d.getFullYear();
  mon = d.getMonth() + 1;
  day = d.getDate();
  let s = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day);
  return s;
}

/**
 * @description 格式化金额
 * @param number：要格式化的数字
 * @param decimals：保留几位小数 默认0位
 * @param decPoint：小数点符号 默认.
 * @param thousandsSep：千分位符号 默认为,
 */
export const formatMoney = (number, decimals = 0, decPoint = '.', thousandsSep = ',') => {
  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  let n = !isFinite(+number) ? 0 : +number
  let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  let s = ''
  let toFixedFix = function (n, prec) {
    let k = Math.pow(10, prec)
    return '' + Math.ceil(Math.round(n * k)) / k
  }
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  let re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}

/**
 *首页：展示或隐藏快速定位栏目
 */
export const sliderFloorNav = () => {
  let r = '';
  let p = $(window).height();
  if (r) {
    $(".elevator").css("top", p - $(".elevator").height() - 100)
  }
  $(window).scroll(function () {
    if ($(".elevator")) {
      let b = $(this).scrollTop();
      if (r) {
        let a = b + $(window).height() - $(".elevator").height() - 100;
        $(".elevator").css("top", a)
      }
    }
  });

  let n = $(".mod_index_floor");
  let q = $(".elevator");
  let f = [];
  let l = 0;
  let k = q.find("li");

  function o() {
    f = [];
    for (let a = 0; a < n.length; a++) {
      f.push(n.eq(a).offset().top)
    }
  }

  q.delegate("li", "click", function () {
    o();
    l = $(this).index();
    $("body,html").stop().animate({scrollTop: f[l] - 60})
  });
  $(window).scroll(function () {
    if (q) {
      let a = $(".help-info").offset().top - 60;
      let b = $(window).scrollTop();
      o();

      if (b < f[0] - 200 || b > a) { //还没滚动到地方，则隐藏导航条
        q.fadeOut();  //fadeOut() 方法使用淡出效果来隐藏被选元素，假如该元素是隐藏的。
        k.removeClass("current");
      } else {
        q.fadeIn();
      }
      if (b > f[l]) {  //滚动到哪一个层了
        l++;
      }
      if (b < f[l - 1]) {
        l--;
      }
      k.eq(l).addClass("current").siblings().removeClass("current");
    }
  })

}

/**
 *收藏良药购
 */
export const addFavorite = (title, url) => {
  try {
    window.external.addFavorite(url, title);
  } catch (e) {
    try {
      window.sidebar.addPanel(title, url, "");
    } catch (e) {
      alert("抱歉，您所使用的浏览器无法完成此操作。\n\n加入收藏失败，请使用Ctrl+D进行添加");
    }
  }
}

/**
 * 分享到腾讯微博*/
export const dzdposttoWb = (t) => {
  //let f=encodeURI(document.title+" 1号商城，品质保证，网上优选 ");
  let c = encodeURI(window.location);
  let e = "2fc26c2514bb48ec891170ce68db2683";
  let a = encodeURI;
  let b = "";
  let d = "http://v.t.qq.com/share/share.php?title=" + t + "&url=" + encodeURIComponent(c) + "&appkey=" + e + "&site=" + a + "&pic=" + b;
  window.open(d, "转播到腾讯微博", "width=700, height=580, top=180, left=320, toolbar=no, menubar=no, scrollbars=no, location=yes, resizable=no, status=no");
};
/**
 * 结算页*/
export const doSelectConsignee = () => { //收件人
  let $Document = $(document);
  let $J_consigneeList = $Document.find(".J_consigneeList");

  $J_consigneeList.delegate("li", "click", function (e) {
    $J_consigneeList.find(".item-selected").each(function () {
      $(this).removeClass("item-selected");
    });
    if (!$(this).find(".consignee-item").hasClass("item-selected")) {
      $(this).find(".consignee-item").addClass("item-selected");
    }
  });
};
const show = function (obj) {
  let $J_guideBox = $(obj).parents(".J_guideBox");
  if ($(obj).hasClass("opened")) { // 是展开的
    $(obj).removeClass("opened");
    $J_guideBox.removeClass("extend");
    $(obj).find("span").text("更多");
    $(obj).find("i").removeClass("el-icon-arrow-up");
    $(obj).find("i").addClass("el-icon-arrow-down");
  } else { // 是收起的
    $J_guideBox.addClass("extend");
    $(obj).addClass("opened");
    $(obj).find("span").text("收起");
    $(obj).find("i").addClass("el-icon-arrow-up");
    $(obj).find("i").removeClass("el-icon-arrow-down");
  }
};
const showMc = function (obj) {
  this.reset();
  let status = this.status, $J_guideBox = $(obj).parents(".J_guideBox");
  let $J_submitBtns = $J_guideBox.find(".J_submitBtns");
  $J_submitBtns.show();
  $J_guideBox.addClass("multiple");
  $J_guideBox.find(".J_multipleChoice").hide();
  this.isMultipleChoice = true
};
const hideMc = function (obj) {
  let status = this.status;
  let $J_guideBox = $(obj).parents(".J_guideBox")
  let $J_submitBtns = $J_guideBox.find(".J_submitBtns");
  $J_submitBtns.hide();
  $J_guideBox.find(".J_multipleChoice").show();
  $J_guideBox.removeClass("multiple");
  // 移除选中的LI的样式
  $J_guideBox.find(".icon_selected_close").remove();
  $J_guideBox.find(".mul_selected").removeClass("mul_selected");
  this.isMultipleChoice = false
};
// 每次只能有一个多选， 其它的复位
const reset = function () {
  let status = this.status, $Document = $(document);
  $Document.find(".J_submitBtns").hide();
  $Document.find(".J_multipleChoice").show();
  $Document.find(".J_guideBox").removeClass("multiple");
  this.status = 0;
  this.isMultipleChoice = false
};
const multipleChoice = function ($target) {
  if ($target.hasClass("mul_selected")) {
    $target.removeClass("mul_selected").attr("title",
      $target.find("img").attr("alt"))
      .find(".icon_selected_close").remove();
    return
  }
  $target.addClass("mul_selected").attr("title", "\u53d6\u6d88")
    .append('<i class="icon_selected_close iconSearch"></i>')
};
const submit = function ($target) {
  let $J_guideBox = $target.parents(".J_guideBox")
  let $J_content = $J_guideBox.find(".J_content"), $selected = $J_content
    .find(".mul_selected"), val = [], paramObj = {};
  if (!$selected.length)
    return;
  $selected.each(function (i, el) {
    val.push($(el).attr("data-id"))
  });
  paramObj[$target.attr("data-type")] = val.join(",");
};
// 商品搜索页，搜索条件特效方法
export const addEventForSearchCategory = function () {
  let self = this;
  let $Document = $(document);
  let $J_moreDis = $Document.find(".J_moreDis");
  let $J_moreChoice = $Document.find(".J_moreChoice");
  let $J_content = $Document.find(".J_content");
  let $J_submit = $Document.find(".J_submit");
  let $J_cancel = $Document.find(".J_cancel");
  $J_moreDis.on("click", function (e) {
    show(this)
  });
  $J_moreChoice.on("click", function (e) {
    showMc(this)
  });
  $J_content.delegate("a", "click", function (e) {
    if (this.isMultipleChoice) {
      e.preventDefault();
      multipleChoice($(this))
    }
  });
  $J_submit.on("click", function (e) {
    e.preventDefault();
    submit($(this))
  });
  $J_cancel.on("click", function (e) {
    e.preventDefault();
    hideMc(this)
  })
};
//生成订单页
export const toggleDetail = function (obj) {
  let $obj = $(obj);
  if ($obj.hasClass("opened")) {
    $(obj).removeClass("opened");
  } else {
    $(obj).addClass("opened");
  }
  $(obj).parents(".J_itemExtra").find(".J_groupList").toggle();
};
export const showConsigneeAll = function () {
  $("#consigneeItemAllClick").addClass("hide");
  $("#consigneeItemHideClick").removeClass("hide");
  $("#consignee1").removeClass("consignee-off");
  $("#del_consignee_type").val("0");
  $(".consignee-item").parents("li").css("display", "list-item");
  let _height = ($('.ui-scrollbar-main .consignee-scroll ul li').length * 42) + "px";
  $('.consignee-cont').css({'height': _height});
  $('.ui-scrollbar-wrap').css({'height': _height});
};
export const hideConsigneeAll = function () {
  $("#consigneeItemAllClick").removeClass("hide");
  $("#consigneeItemHideClick").addClass("hide");
  $("#consignee1").addClass("consignee-off");
  $("#del_consignee_type").val("1");
  $('.consignee-cont').css({'height': '42px'});
  $('.ui-scrollbar-bg').css('display', 'none');
  $('.ui-scrollbar-item-consignee').css('display', 'none');
  $('.ui-scrollbar-wrap').css('height', '42px');
  $('#consignee-content ul').css({
    'top': '0px',
    'position': 'absolute'
  });
  // 地址列表切换至第一页
  let li_selected = $(".consignee-item.item-selected").parent("li");//当前选中li
  let first_li = $(".consignee-item").parents("li").last();//当前列表第一项
  let _tempstr = first_li.find("div span").first().html();
  if (_tempstr && _tempstr.indexOf("默认地址") > -1) {
    // 1.插入在默认地址之后
    li_selected.clone().insertAfter(first_li);
  } else {
    // 2.插入在地址列表第一位
    li_selected.clone().insertBefore(first_li);
  }
  // 收起并定位第一页功能
  if (li_selected.html() != undefined) {
    $(".consignee-item").parents("li").css("display", "none");
    $(".consignee-item.item-selected").parent("li").css("display", "list-item");
  }
  li_selected.remove();
};
/**
 * 获取style样式
 */
export const getStyle = (element, attr, NumberMode = 'int') => {
  let target;
  // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
  if (attr === 'scrollTop') {
    target = element.scrollTop
  } else if (element.currentStyle) {
    target = element.currentStyle[attr]
  } else {
    target = document.defaultView.getComputedStyle(element, null)[attr]
  }
  // 在获取 opactiy 时需要获取小数 parseFloat
  return NumberMode === 'float' ? parseFloat(target) : parseInt(target)
};
